import React, { useState } from "react";
import { useBCMSContext, useRoute, useParams, BCMSRecord } from "@bcm-dev/bcms-vite";
import MainContentContainer, { MainContentHeader } from "components/shared/containers/MainContentContainer";
import FormContainer, { FormButtonContainer, FormRow } from "components/shared/containers/FormContainer";
import UITextInput from "components/ui/UITextInput";
import { UICancelButton, UIPrimaryButton } from "components/ui/UIButton";
import Classes, { Card } from "model";

import "./styles.css";

/**
 * @function ActivateCardVerificationPage
 * @return {React.Component}
 * @exported true
 * @description The main component for ActivateCardVerificationPage
 */
export default function ActivateCardVerificationPage(props) {
  //const controller = useBCMSContext();
  const controller = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, controller);

  const [ state, setState ] = useState({ date: "", code: "" });
  const update = prop => value => setState({ ...state, [ prop ] : value });

  const navigate = useRoute();
  const cardID = useParams().cardID;

  const activateBtn = evt => {
    const card = Card.initByID(cardID);
    card.active = true;

    BCMSRecord.batch([
      Card.update(card)
    ], controller, Classes);

    navigate(`/home/activatecard/${ cardID }`);
  };
  const cancelBtn = evt => navigate(`/home/recenttransactions/${ cardID }`);

  return (
    <MainContentContainer className="activate-card-verification-page" header={<MainContentHeader text="Card Verification" />}>
      <div className="content-container">
        <p>Physical card must be present to activate.</p>
      </div>
      <FormContainer>
        <FormRow>
          <UITextInput placeholder="Expiration Date (MM/YY)*" value={ state.date } onChange={ update("date") } dataPoint="Activate_Card_Expiration" />
        </FormRow>
        <FormRow>
          <UITextInput type="password" placeholder="Security Code (CVV/CVV2)*" value={ state.code } onChange={ update("code") } dataPoint="Activate_Card_Security" />
        </FormRow>
        <FormButtonContainer>
          <UIPrimaryButton text="Activate" onClick={ activateBtn } dataPoint="Activate_Card_Confirm" />
          <UICancelButton text="Cancel" onClick={ cancelBtn } />
        </FormButtonContainer>
      </FormContainer>
    </MainContentContainer>
  );
}